import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, ShieldCheck, Star, Award, CheckCircle2, ArrowRight, Clock } from 'lucide-react';
export function QuoteForm() {
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  return <section id="quote-form" className="bg-brand-50 py-20 md:py-28 scroll-mt-24" data-id="element-529">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-530">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-531">
          {/* Left: pitch + testimonial */}
          <div className="lg:col-span-5" data-id="element-532">
            <div className="text-xs font-semibold uppercase tracking-widest text-brand mb-4" data-id="element-533">
              Start Here
            </div>
            <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight leading-[1.1] text-ink mb-7" data-id="element-534">
              Free on site quote. Perth wide.
            </h2>
            <p className="text-lg leading-relaxed text-stone-700 max-w-md mb-8" data-id="element-535">
              Tell us about your home. Mike will visit, measure, and recommend
              in plain English. No fee. No follow up sales calls unless you ask.
            </p>

            <div className="space-y-3 mb-10" data-id="element-536">
              {['Same business day callback (Mon to Thu 9 to 4, Fri 9 to 2)', 'Fixed price quote in writing within 48 hours', 'We do not share or sell your details. Ever.'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-537">
                  <CheckCircle2 size={20} className="text-success mt-0.5 flex-shrink-0" data-id="element-538" />
                  <span className="text-base text-ink" data-id="element-539">{item}</span>
                </div>)}
            </div>

            {/* Testimonial */}
            <div className="bg-white rounded-2xl p-6 border border-stone-200 shadow-md mb-8" data-id="element-540">
              <div className="flex gap-0.5 mb-3" aria-label="5 star review" data-id="element-541">
                {[0, 1, 2, 3, 4].map(i => <Star key={i} size={16} className="fill-accent text-accent" data-id="element-542" />)}
              </div>
              <p className="text-base text-ink leading-relaxed mb-3" data-id="element-543">
                "Mike quoted us personally, gave us straight advice and the
                install was spotless. Cleaner than when they arrived. Highly
                recommended."
              </p>
              <div className="text-sm text-stone-600" data-id="element-544">
                <strong className="text-ink" data-id="element-545">Sarah K.</strong> Karrinyup, ducted
                reverse cycle
              </div>
            </div>

            {/* Trust badges */}
            <div className="grid grid-cols-2 gap-4 pt-6 border-t border-stone-200" data-id="element-546">
              <div className="flex items-center gap-3" data-id="element-547">
                <Award size={18} className="text-brand flex-shrink-0" data-id="element-548" />
                <div data-id="element-549">
                  <div className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold" data-id="element-550">
                    Accreditation
                  </div>
                  <div className="text-sm font-bold text-ink" data-id="element-551">
                    Diamond Dealer
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-552">
                <ShieldCheck size={18} className="text-brand flex-shrink-0" data-id="element-553" />
                <div data-id="element-554">
                  <div className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold" data-id="element-555">
                    Insured
                  </div>
                  <div className="text-sm font-bold text-ink" data-id="element-556">
                    $20M public liability
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-557">
                <Star size={18} className="text-brand flex-shrink-0" data-id="element-558" />
                <div data-id="element-559">
                  <div className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold" data-id="element-560">
                    Reviews
                  </div>
                  <div className="text-sm font-bold text-ink" data-id="element-561">
                    5.0 from 75 Google
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-562">
                <Clock size={18} className="text-brand flex-shrink-0" data-id="element-563" />
                <div data-id="element-564">
                  <div className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold" data-id="element-565">
                    Trading since
                  </div>
                  <div className="text-sm font-bold text-ink" data-id="element-566">
                    1995, ABN 87 134 927 585
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-7" data-id="element-567">
            <div className="bg-white rounded-3xl p-6 sm:p-8 lg:p-10 shadow-2xl border border-stone-200" data-id="element-568">
              {/* Brand banner */}
              <div className="-mx-6 sm:-mx-8 lg:-mx-10 -mt-6 sm:-mt-8 lg:-mt-10 px-6 sm:px-8 lg:px-10 py-5 bg-brand text-white rounded-t-3xl mb-7" data-id="element-569">
                <div className="text-xs font-semibold uppercase tracking-widest text-white/80 mb-1" data-id="element-570">
                  Free Fixed Price Quote
                </div>
                <div className="text-xl font-bold tracking-tight" data-id="element-571">
                  Mike calls back same business day.
                </div>
              </div>

              {submitted ? <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="py-12 text-center" data-id="element-572">
                  <div className="w-16 h-16 rounded-full bg-success/15 text-success flex items-center justify-center mx-auto mb-5" data-id="element-573">
                    <CheckCircle2 size={32} data-id="element-574" />
                  </div>
                  <h3 className="text-2xl font-bold text-ink mb-2" data-id="element-575">Got it!</h3>
                  <p className="text-base text-stone-600 max-w-sm mx-auto" data-id="element-576">
                    Mike will call you within 2 business hours to book your free
                    on site quote.
                  </p>
                </motion.div> : <form onSubmit={e => {
              e.preventDefault();
              setSubmitted(true);
            }} className="space-y-5" data-id="element-577">
                  {/* Progress */}
                  <div className="flex items-center gap-2 mb-1" data-id="element-578">
                    <div className={`flex-1 h-1.5 rounded-full transition-colors ${step >= 1 ? 'bg-brand' : 'bg-stone-200'}`} data-id="element-579"></div>
                    <div className={`flex-1 h-1.5 rounded-full transition-colors ${step >= 2 ? 'bg-brand' : 'bg-stone-200'}`} data-id="element-580"></div>
                    <span className="text-[11px] font-semibold text-stone-500 uppercase tracking-wider ml-2 tabular-nums" data-id="element-581">
                      Step {step} of 2
                    </span>
                  </div>

                  {step === 1 ? <>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-582">
                        <div data-id="element-583">
                          <label htmlFor="qf-name" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-584">
                            Your name *
                          </label>
                          <input type="text" id="qf-name" required placeholder="e.g. Sarah" className="w-full h-12 px-4 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base placeholder:text-stone-400" data-id="element-585" />
                        </div>
                        <div data-id="element-586">
                          <label htmlFor="qf-phone" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-587">
                            Mobile *
                          </label>
                          <input type="tel" id="qf-phone" required placeholder="04XX XXX XXX" className="w-full h-12 px-4 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base placeholder:text-stone-400 tabular-nums" data-id="element-588" />
                        </div>
                      </div>

                      <div data-id="element-589">
                        <label htmlFor="qf-suburb" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-590">
                          Your suburb *
                        </label>
                        <input type="text" id="qf-suburb" required placeholder="e.g. Karrinyup" className="w-full h-12 px-4 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base placeholder:text-stone-400" data-id="element-591" />
                      </div>

                      <button type="button" onClick={() => setStep(2)} className="w-full h-14 rounded-xl bg-accent hover:bg-accent-600 text-ink font-bold text-base transition-all hover:scale-[1.01] flex items-center justify-center gap-2 shadow-lg shadow-accent/20" data-id="element-592">
                        Continue
                        <ArrowRight size={16} strokeWidth={2.5} data-id="element-593" />
                      </button>
                    </> : <>
                      <div data-id="element-594">
                        <label htmlFor="qf-service" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-595">
                          What do you need?
                        </label>
                        <select id="qf-service" className="w-full h-12 px-4 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base appearance-none cursor-pointer" data-id="element-596">
                          <option data-id="element-597">I am not sure, help me decide</option>
                          <option data-id="element-598">Ducted install (whole home)</option>
                          <option data-id="element-599">Split install (one room)</option>
                          <option data-id="element-600">Multi head split (2 to 4 rooms)</option>
                          <option data-id="element-601">Reverse cycle replacement</option>
                          <option data-id="element-602">Commercial install</option>
                          <option data-id="element-603">Old unit removal</option>
                        </select>
                      </div>

                      <div data-id="element-604">
                        <label htmlFor="qf-timing" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-605">
                          When are you hoping to install?
                        </label>
                        <select id="qf-timing" className="w-full h-12 px-4 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base appearance-none cursor-pointer" data-id="element-606">
                          <option data-id="element-607">This week (urgent)</option>
                          <option data-id="element-608">This month</option>
                          <option data-id="element-609">Next 2 to 3 months</option>
                          <option data-id="element-610">Just getting quotes</option>
                        </select>
                      </div>

                      <div data-id="element-611">
                        <label htmlFor="qf-message" className="block text-xs font-bold text-ink mb-2 uppercase tracking-wider" data-id="element-612">
                          Anything else?{' '}
                          <span className="text-stone-400 normal-case tracking-normal font-normal" data-id="element-613">
                            (optional)
                          </span>
                        </label>
                        <textarea id="qf-message" rows={3} placeholder="e.g. 3 bed single storey, want to cool the bedrooms only..." className="w-full px-4 py-3 rounded-xl bg-white border-2 border-stone-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all text-base resize-none placeholder:text-stone-400" data-id="element-614"></textarea>
                      </div>

                      <input type="hidden" name="gclid" data-id="element-615" />
                      <input type="hidden" name="utm_source" data-id="element-616" />
                      <input type="hidden" name="utm_medium" data-id="element-617" />
                      <input type="hidden" name="utm_campaign" data-id="element-618" />
                      <input type="hidden" name="utm_term" data-id="element-619" />
                      <input type="hidden" name="page_uri" data-id="element-620" />
                      <input type="hidden" name="referrer" data-id="element-621" />

                      <div className="flex gap-3" data-id="element-622">
                        <button type="button" onClick={() => setStep(1)} className="h-14 px-6 rounded-xl border-2 border-stone-200 hover:border-brand text-ink font-semibold text-sm transition-all" data-id="element-623">
                          Back
                        </button>
                        <button type="submit" className="flex-1 h-14 rounded-xl bg-accent hover:bg-accent-600 text-ink font-bold text-base transition-all hover:scale-[1.01] flex items-center justify-center gap-2 shadow-lg shadow-accent/20" data-id="element-624">
                          Send to Mike
                          <ArrowRight size={16} strokeWidth={2.5} data-id="element-625" />
                        </button>
                      </div>
                    </>}

                  <p className="text-center text-xs text-stone-500 flex items-center justify-center gap-1.5 pt-2" data-id="element-626">
                    🔒 Free quote. No obligation. No spam. No sales tactics.
                  </p>

                  <div className="flex items-center justify-center gap-2 pt-3 border-t border-stone-100 text-xs text-stone-500" data-id="element-627">
                    <Phone size={12} data-id="element-628" />
                    Or call Mike directly:
                    <a href="tel:+61864043888" className="font-bold text-brand hover:underline" data-id="element-629">
                      08 6404 3888
                    </a>
                  </div>
                </form>}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}